import { userContext } from '../userManager';

export const apiWatchlistsGet = (watchlistId) =>
  userContext.apiCall({
    url: `/watchlists/${watchlistId}`,
    method: 'GET',
  });

export const apiWatchlistsDelete = (watchlistId) =>
  userContext.apiCall({
    url: `/watchlists/${watchlistId}`,
    method: 'DELETE',
  });

export const apiWatchlistsPatch = (watchlistId, { name }) =>
  userContext.apiCall({
    url: `/watchlists/${watchlistId}`,
    method: 'PATCH',
    body: { name },
  });

export const apiWatchlistsInstrumentsGet = (watchlistId) =>
  userContext.apiCall({
    url: `/watchlists/${watchlistId}/watchlist-instruments`,
    method: 'GET',
  });

export const apiWatchlistsInstrumentsPost = (watchlistId, { instrumentId, productType }) =>
  userContext.apiCall({
    url: `/watchlists/${watchlistId}/watchlist-instruments`,
    method: 'POST',
    body: { watchlistId, instrumentId, productType },
  });

export const apiWatchlistsInstrumentsDelete = (watchlistId, instrumentId) =>
  userContext.apiCall({
    url: `/watchlists/${watchlistId}/watchlist-instruments/${instrumentId}`,
    method: 'DELETE',
    body: { watchlistId, instrumentId },
  });
